<template>
  <div class="result-screen">
    <header class="result-header">
      <v-btn icon class="result-back" @click="$emit('back')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <img src="@/assets/header.png" alt="APA" />
    </header>
    <div class="result-body">
      <div class="result-card tw-p-6 md:tw-p-10 tw-text-center">
        <v-avatar color="success" size="72">
          <v-icon color="white" size="40">mdi-check</v-icon>
        </v-avatar>
        <h2 class="tw-text-xl md:tw-text-2xl tw-font-bold tw-mt-5 tw-mb-1">
          Claim received
        </h2>
        <p class="tw-text-sm c-gray-text tw-max-w-sm tw-mx-auto">
          Thank you — we've received your claim. A confirmation was sent to your
          phone and email.
        </p>

        <div
          class="tw-rounded-xl tw-border tw-border-gray-200 tw-bg-gray-50 tw-p-4 tw-my-6"
        >
          <div class="tw-text-xs tw-font-bold c-gray-text tw-tracking-wide">
            YOUR CLAIM REFERENCE
          </div>
          <div
            class="tw-text-xl md:tw-text-2xl tw-font-bold c-blue-text tw-mt-1"
            data-testid="claim-ref"
          >
            {{ claimRef }}
          </div>
        </div>

        <v-btn outlined block x-large class="tw-mt-6" @click="$emit('done')">
          Done
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessScreen',
  emits: ['done', 'back'],
  props: {
    claimRef: { type: String, required: true },
  },
}
</script>

<style scoped>
.result-screen {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 48px);
  background: #f7f9fc;
}

.result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 34px;
}

.result-back {
  background: #f4f7fb;
}

.result-header img {
  width: 96px;
}

.result-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px 24px;
}

.result-card {
  width: 100%;
  max-width: 460px;
  border: 1px solid #e4e9f1;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 18px 44px rgba(17, 76, 172, 0.08);
}

@media (max-width: 640px) {
  .result-screen {
    min-height: 100vh;
  }

  .result-header {
    padding: 16px 20px;
  }

  .result-header img {
    width: 72px;
  }
}
</style>
